
<div id="print-rec-list">
  <Row>
    <h1 style="font-size:1.1rem; color:#003d79; letter-spacing: 0.5px; font-weight:400;float:left;">Recommendations By Grade</h1>
    <span style="float:right;">
      <Button fill onClick={() => printDiv('print')} style="display:inline-block"><i class="icon f7-icons">printer</i> Print This List</Button>
      <Button large small onClick={() => handleMyBookmarks()} style="display:inline-block"><i class="icon f7-icons">bookmark</i>My Bookmarks</Button>
    </span>
  </Row>
<div>
  <div style="padding: 5px 0 10px; font-size: 16px; font-weight: bold; color: #008ab0;">
    {#if sSearchList}Search: {sSearchList}{/if}
    {#if bIsMyBookmarks}
      My Bookmarks <Button small onClick={() => handleResetRec()} style="display:inline-block"><i class="icon f7-icons">arrow_clockwise</i> Clear</Button>
    {/if}
  </div>
  <FilterGrade />
  {#if recommendations}
    {#each gradeKeyArr as key}
    <Row>
        <div class="grade-category" style={"background-color:"+key.backgroundColor+"; color:" + key.color}>
        {key.grade} - {key.status} ({recGroupedByGrade[key.grade] && recGroupedByGrade[key.grade].length})</div>
    </Row>
    {#if recommendations.length > 0 && key.grade && recGroupedByGrade[key.grade] && recGroupedByGrade[key.grade].length > 0}
    <div>
      {#each recGroupedByGrade[key.grade] as recommendation, i}
        <RecomendationListItem recommendation={recommendation} generalRec={oData.generalRecommendations[recommendation.general]}/>
      {/each}
    </div>
    {/if}
    {#if !recGroupedByGrade || !recGroupedByGrade[key.grade] || recGroupedByGrade[key.grade].length < 1} 
      <p>There are no recommendations.</p>
    {/if}
    {/each}
    {#if recommendations.length < 1} 
      <p>There are no recommendations.</p>
    {/if}
  {:else}
    <div class="preloader-modal" style="background: transparent;">
      <Preloader size={70} color="blue"></Preloader>
    </div>
  {/if} 
</div>
</div>
<script>
  import {
    Button,
    Preloader,
    Row,
    Segmented
  } from 'framework7-svelte';
  import { onDestroy } from 'svelte';
  import { bIsFilterStore, oFilterStore, searchData, fFilterDataByInput, fIsMetric, arrBookmarkedRec, bIsRecReset } from '../stores.js';
  import { groupBy, fCalculateBMI, fConvertToFtIn, fResetFilter } from '../utils.js';
  import FilterGrade from './FilterGrade.svelte';
  import RecomendationListItem from './RecommendationListItem.svelte';
  import {GRADE_KEY_CONST} from '../constants.js';

  //$:handleResetRec($bIsRecReset)

  let recommendations;
  let recGroupedByGrade;
  let gradeKeyArr;
  let sQuery = '';
  let sSearchList = '';
  let oData; 
  let oDefaultData;
  let oFilter;
  let isMetric;
  let arrBookmarkedRecommendations = [];
  let bIsMyBookmarks = false;
  let bIsFiltered = false;

  let unsubscribeFilter;
  let unsubscribeIsFilter;

  const unsubscribeResetData = bIsRecReset.subscribe(val => {
  });
  onDestroy(unsubscribeResetData);

  const unsubscribeSearchData = searchData.subscribe(obj => {
    oData = obj;
    oDefaultData = obj;
    // get bookmarked recommendations from stores
    const unsubscribeBookmarkData = arrBookmarkedRec.subscribe(arr => {
      arrBookmarkedRecommendations = arr;
    });
    onDestroy(unsubscribeBookmarkData);

    unsubscribeIsFilter = bIsFilterStore.subscribe(status => {
      unsubscribeFilter = oFilterStore.subscribe(oFilterObj => {
        oFilter = oFilterObj;
          if (status) {
            sQuery = convertFiltersToQuery(oFilter);
            sSearchList = getSearchList(oFilter);
            bIsFiltered = true;
          } else {
            // no filters
            bIsFiltered = false;
          }
          getSearchData(obj, bIsFiltered);
      });
    });
  });

  onDestroy(unsubscribeSearchData);
  onDestroy(unsubscribeFilter);
  onDestroy(unsubscribeIsFilter);

  function printDiv(divName) {
    document.getElementById("print-rec-list").classList.add("section-to-print-body");
    window.print();
    document.getElementById("print-rec-list").classList.remove("section-to-print-body");
  }

  function handleMyBookmarks() {
    bIsMyBookmarks = true;
    getSearchData(oDefaultData, false);
    sSearchList = "";
  }

  // reset recommendations, filters
  function handleResetRec(isReset) {
    if (isReset) {
      bIsMyBookmarks = false;
      getSearchData(oDefaultData, false);
      sSearchList = "";
    } else {
      bIsRecReset.set(true);
      bIsMyBookmarks = false;
      getSearchData(oDefaultData, false);
      sSearchList = "";
    }
  }

  function getSearchList (filterFieldObj) {
    let str = '';
    let arrsSearch = [];
    isMetric = fIsMetric();
    for (var key in filterFieldObj) {
        const valArr = filterFieldObj[key].values;
        if (valArr.length < 1 || 
            valArr[0] === null || 
            valArr[0] === undefined ||
            key === 'heightFt' ||
            key === 'heightIn' ||
            key === 'height' ||
            key === 'heightMetric' ||
            key === 'weight' ||
            key === 'weightMetric')  {continue;}
        
        if (key === 'pregnant' || key === 'sexuallyActive' || key === 'tobacco') {
          if (valArr.includes('Y')) {
            arrsSearch.push(filterFieldObj[key].displayName);
          }
          continue;
        }

        if (key === 'grade') { continue; };

        if (key === 'height') {
          if (!valArr[0]) { continue; }
          //const isMetric = filterFieldObj.height.system != 'US' ? true : false;
          if (!isMetric) {
            const arriHeight = fConvertToFtIn(valArr[0]);
            arrsSearch.push(`${arriHeight[0]}'${arriHeight[1]}"`);
          } else {
            arrsSearch.push(`${valArr[0]} cm`);
          }
          continue;
        }

        valArr.forEach(val => {
          let strVal = `${val}`;
          if (key === 'age') {
            strVal += ' yrs';
          }
          arrsSearch.push(strVal);
        });

    }

    // weight and height based on if the unit is metric or english unit 
    const iHeightVal = filterFieldObj.height && filterFieldObj.height.values[0];
    const iWeightVal = filterFieldObj.weight && filterFieldObj.weight.values[0];

    if (isMetric) {
      // weight in kg
      if (iWeightVal) {
        const weightVal = filterFieldObj.weightMetric.values[0] || 0;
        const weightUnit = filterFieldObj.weightMetric.unit;
        arrsSearch.push(`${weightVal} ${weightUnit}`);
      }
      // height in cm
      if (iHeightVal) {
        const heightVal = filterFieldObj.heightMetric.values[0] || 0;
        const heightUnit = filterFieldObj.heightMetric.unit;
        arrsSearch.push(`${heightVal} ${heightUnit}`);
      }
    } else {
      // weight in lb 
      if (iWeightVal) {
        const weightVal = filterFieldObj.weight.values[0] || 0;
        const weightUnit = filterFieldObj.weight.unit;
        arrsSearch.push(`${weightVal} ${weightUnit}`);
      }
      // height in ft and in
      if (iHeightVal) {
        const heightFt = filterFieldObj.heightFt.values[0] || 0;
        const heightIn = filterFieldObj.heightIn.values[0] || 0;
        arrsSearch.push(`${heightFt}'${heightIn}"`);
      }
    }

    // calculate BMI
    const oBMI = (!iHeightVal || !iWeightVal) ? null : fCalculateBMI(iWeightVal, iHeightVal);
    oBMI && oBMI.value && arrsSearch.push(`BMI (${oBMI.value} ${oBMI.label.display})`);

    return arrsSearch.join(", ");
  }

  function convertFiltersToQuery (filterFieldObj) {
        let str = '';
        for (let key in filterFieldObj) {
            const valArr = filterFieldObj[key].values;
            if (valArr.length > 0) {
              valArr.forEach(val => {
                str += `${key}=${val}&`;
              });
            }
        }
        return str;
  }

  async function getSearchData(obj, isFiltered) {
    if (!oData) {return;}

    // mark which recommendations are bookmarked
    oData && oData.specificRecommendations.forEach(rec => {
      if (arrBookmarkedRecommendations.indexOf(rec.id) > -1) {
        rec.bookmark = true;
      } else {
        rec.bookmark = false;
      }
    });
    oData = isFiltered ? fFilterDataByInput(oData, oFilter) : oData;    
    recommendations = isFiltered ? oData && oData.filteredSpecificRecommendations : oData && oData.specificRecommendations;

    // get my bookmarks - isFiltered should be false
    if (bIsMyBookmarks == true) {
      // filtering bookmarked recommendations
      recommendations = recommendations.filter(rec => {
        if (arrBookmarkedRecommendations.indexOf(rec.id) > -1) {
          rec.bookmark = true;
          return true;
        } 
        return false;
      });
    }

    // group recommendations by grade
    recGroupedByGrade = recommendations && groupBy(recommendations, 'grade');
    Object.keys(recGroupedByGrade).forEach(key => {
      recGroupedByGrade[key] = recGroupedByGrade[key].sort((a, b) =>a.title.localeCompare(b.title));
    });

    // Hardcoded the grade key value as the order from the endpoint are subject to change.
    gradeKeyArr = recGroupedByGrade && Object.keys(recGroupedByGrade);
    gradeKeyArr = gradeKeyArr && gradeKeyArr.sort((a, b) =>a.localeCompare(b));
    gradeKeyArr = GRADE_KEY_CONST.filter(key => gradeKeyArr.includes(key.grade));
  }
</script>
<style>
.grade-category {
  background-color: #beeeb0;
  padding: 5px;
  margin-top: 5px;
  margin-bottom: 10px;
  letter-spacing: 0.3px;
  width: 100%;
  font-weight: bold;
}
.button-row {
  margin-top: 5px;
  margin-bottom: 5px;
}
</style>